export default __webpack_public_path__ + "static/halloween_mobile-c1bb9652668076a259b06ebdf1022fc1.gif";